import _ from 'lodash'
import en from './en'
import ru from './ru'

const locales = { en, ru }

export { locales }

export function getLocaleMessages(locale) {
	if (!locales[locale]) {
		console.log(`Locale messages for ${locale} could not be found.`) // eslint-disable-line
		return
	}

	const messages = {}
	const sections = locales[locale]

	_.each(sections, (section, index) => {
		messages[index] = {}
		_.each(section, (message, key) => {
			messages[index][key] = message
			messages[`${index}.${key}`] = message
		})
	})

	return messages
}

export const getLocaleTranslator = (path) => {
	const { [path]: messages } = getLocaleMessages('ru')
	return (code, data) => {
		return data?.length
			? data.reduce((acc, item) => {
					return acc.replace(':data', item || '')
			  }, messages[code])
			: messages[code].replace(/:data/g, '').trim()
	}
}
